module.exports = __webpack_public_path__ + "static/media/logo512.a3844f30.png";